import React, { useState } from 'react';
import PropTypes from 'prop-types';
// Import Shared Components
import { Title, InputGroup, Loader, Input, Label } from 'shared-components';
// Import Local Components
import AuthForm from './AuthForm';
import PwdEyeButton from './PwdEyeButton';
// Import Styles
import { PasswordFieldWrapper } from './AuthForm/styles';
// Import Layouts
import AuthLayout from '../layouts/AuthLayout';

function Login({
  email,
  password,
  loading,
  onUpdateEmail,
  onUpdatePassword,
  onLoginSubmit,
  handleLoginKeyUp,
  formError,
  forgotPassword,
}) {
  const [passwordType, setPasswordType] = useState('password');

  if (loading)
    return (
      <AuthLayout>
        <Title>Logging In...</Title>
        <Loader />
      </AuthLayout>
    );

  return (
    <AuthForm
      title="Login"
      error={formError}
      onSubmit={onLoginSubmit}
      onKeyUp={handleLoginKeyUp}
      secondaryButtonText="Forgot Password"
      onClick={forgotPassword}
      submitButtonText="Submit"
    >
      <InputGroup
        label="Email:"
        labelFor="email"
        dataId="login-form-email-input"
        value={email}
        onChange={onUpdateEmail}
        type="email"
      />
      <div data-id="login-form-password-input">
        <Label htmlFor="password">Password:</Label>
        <PasswordFieldWrapper>
          <Input
            name="password"
            value={password}
            onChange={onUpdatePassword}
            type={passwordType}
          />
          <PwdEyeButton type={passwordType} settype={setPasswordType} />
        </PasswordFieldWrapper>
      </div>
    </AuthForm>
  );
}

Login.propTypes = {
  email: PropTypes.string,
  password: PropTypes.string,
  loading: PropTypes.bool,
  onUpdateEmail: PropTypes.func,
  onUpdatePassword: PropTypes.func,
  onLoginSubmit: PropTypes.func,
  handleLoginKeyUp: PropTypes.func,
  formError: PropTypes.string,
  forgotPassword: PropTypes.func,
};

Login.defaultProps = {
  email: '',
  password: '',
  loading: false,
  onUpdateEmail: null,
  onUpdatePassword: null,
  onLoginSubmit: null,
  handleLoginKeyUp: null,
  formError: null,
  forgotPassword: null,
};

export default Login;
